export default "__VITE_ASSET__Dz52_o9f__"